<!-- 試用版申込フォームの進行状況（STEP1〜完了）を表示するステップナビゲーションコンポーネント -->

<template>
  <v-stepper :model-value="current" alt-labels hide-actions flat class="step-nav-wrapper">
    <v-stepper-header>
      <v-stepper-item
        :value="1"
        title="STEP1"
        :complete="current > 1"
        color="primary"
      />

      <v-divider />

      <v-stepper-item
        :value="2"
        title="STEP2"
        :complete="current > 2"
        color="primary"
      />

      <v-divider />

      <v-stepper-item
        :value="3"
        title="確認"
        :complete="current > 3"
        color="primary"
      />

      <v-divider />

      <v-stepper-item
        :value="4"
        title="完了"
        :complete="current > 4"
        color="primary"
      />
    </v-stepper-header>
  </v-stepper>
</template>

<script setup lang="ts">
defineProps<{
  current: number;
}>();
</script>

<style scoped lang="scss">
.step-nav-wrapper {
  margin: 24px auto 50px;
  max-width: 75%;
  background: transparent !important;
  box-shadow: none !important;

  // 円の中の数字を非表示
  :deep(.v-stepper-item__avatar) {
    font-size: 0;
  }
}
</style>
